var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 775,
    height: 718,
    viewBox: "0 0 775 718",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M765.003 395.41L715.191 345.754C708.753 339.225 698.253 339.16 691.816 345.754L586.815 450.691L466.69 571.066L373.659 477.941C367.128 471.379 356.628 471.379 350.159 477.941L300.44 527.629C293.909 534.191 293.909 544.691 300.44 551.191L405.221 656.066L423.19 673.941L454.878 705.753C461.44 712.315 472.066 712.315 478.44 705.753L528.065 656.065L764.94 418.971C771.565 412.503 771.565 402.003 765.003 395.41ZM232.784 460.003L282.471 410.191C324.94 367.816 398.815 367.753 441.252 410.253L466.564 435.565L580.315 327.191V7.19092H4.3147V711.191H324.315L232.784 619.066C189.003 575.129 189.003 503.816 232.784 460.003ZM196.315 71.1909H516.315V135.191H196.315V71.1909ZM196.315 199.191H516.315V263.191H196.315V199.191ZM132.315 391.191H68.3147V327.191H132.315V391.191ZM132.315 263.191H68.3147V199.191H132.315V263.191ZM132.315 135.191H68.3147V71.1909H132.315V135.191ZM196.315 327.191H260.315V391.191H196.315V327.191Z",
    fill: "#05164D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 774.602,
    height: 718,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.ccef9014e7495833e63bd45beebd228b.svg";
export { ForwardRef as ReactComponent };